import { Col, Typography, useTheme } from "@commonlibs";
import { usePartnerPointOfSellColumns } from "ui/partner/hooks/usePartnerPointOfSellColumns/usePartnerPointOfSellColumns";
import { BaseTable } from "./PartnerPointOfSellTable.styles";
import { PartnerPointOfSellTableProps } from "./PartnerPointOfSellTable.types";

const PartnerPointOfSellTable = ({ data = [], isLoading }: PartnerPointOfSellTableProps) => {
    const columns = usePartnerPointOfSellColumns();
    const { spacing } = useTheme();
    return (
        <Col gap={spacing[3]} flex={1} css={{ width: "100%", overflow: "auto" }}>
            <Typography variant="body1Strong">{data[0].name}</Typography>
            <BaseTable data={data} loading={isLoading} columns={columns} enableSorting={false} />
        </Col>
    );
};

export default PartnerPointOfSellTable;
